import * as Models from "../.";

export interface IRegionPricing {
    regionPricingId: number;
    escalator: number;
    rateFloor: number;
    rateCap: number;
    partner: Models.PartnerModel.IPartnerModel;
    productType: string;
    productTypeCode: string;
    epcCap: number;
    regionItcPricings: Models.CostCalculation.RegionItcPricing.IRegionItcPricing[];
}

export class RegionPricing implements IRegionPricing {
    public regionPricingId: number;
    public escalator: number;
    public rateFloor: number;
    public rateCap: number;
    public partner: Models.PartnerModel.IPartnerModel;
    public productType: string;
    public productTypeCode: string;
    public epcCap: number;
    public regionItcPricings: Models.CostCalculation.RegionItcPricing.IRegionItcPricing[];
}
